import { z } from "zod";

export const EPaycardSSNVerificationDeclinedReasonCodes = {
  DOB_MISMATCH: "DOB_MISMATCH",
  NAME_MISMATCH: "NAME_MISMATCH",
  SSN_MISMATCH: "SSN_MISMATCH",
  ADDRESS_MISMATCH: "ADDRESS_MISMATCH",
} as const;

export const paycardSSNVerificationDeclinedReasonCodeSchema = z.nativeEnum(
  EPaycardSSNVerificationDeclinedReasonCodes
);

export type TPaycardSSNVerificationDeclinedReasonCodes =
  (typeof EPaycardSSNVerificationDeclinedReasonCodes)[keyof typeof EPaycardSSNVerificationDeclinedReasonCodes];
